import { IEducationReview } from '@sapientpro/sapientpro-data-models';
import { SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import React from 'react';
import { MouseParallax } from 'react-just-parallax';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Ellipse from '../../../components/Ellipse';
import Slider from '../../../components/SliderComponent/Slider';
import deviceScreenSize, { ScreenSize } from '../../../store/deviceScreenSize';
import EducationReview from './EducationReview';
import styles from './EducationReviews.module.scss';
import { EllipseVariants } from '../../../../constants';

const settings = {
  focus: 0,
  perPage: 1,
  perMove: 1,
  pagination: true,
  arrows: false,
  type: 'loop',
  classes: {
    pagination: `splide__pagination ${styles.pagination}`,
    page: `splide__pagination__page ${styles.pagination__item}`,
  },
};

const EducationReviews = ({ data }: { data: IEducationReview[] }) => {
  const deviceSize = useAtomValue(deviceScreenSize);

  return (
    <section className={classnames(styles.reviews)}>
      <div className={styles.parallax}>
        <MouseParallax
          isAbsolutelyPositioned
          strength={0.05}
        >
          <Ellipse
            variant={EllipseVariants.DRAW}
            size={deviceSize <= ScreenSize.TABLET_PORTRAIT ? 516 : 720}
            className={styles.parallax__draw}
          />
        </MouseParallax>
        <MouseParallax
          isAbsolutelyPositioned
          strength={0.12}
        >
          <Ellipse
            variant={EllipseVariants.NOISE}
            size={deviceSize <= ScreenSize.TABLET_PORTRAIT ? 84 : 117}
            className={styles.parallax__noise}
          />
        </MouseParallax>
        <MouseParallax
          isAbsolutelyPositioned
          strength={0.08}
        >
          <Ellipse
            variant={EllipseVariants.BORDER}
            size={deviceSize <= ScreenSize.TABLET_PORTRAIT ? 28 : 40}
            className={styles.parallax__border}
          />
        </MouseParallax>
      </div>
      <h2 className={classnames(styles.title, 'title3', 'container')}><AnimatedTitle title='Learners Who **Joined Us**' /></h2>
      {data && data.length > 0 && (
        <Slider
          settings={settings}
          classNames={{
            slider: styles.slider,
            track: styles.track,
            navigation: styles.navigation,
            arrow: styles.arrow,
            prevArrow: styles.arrow_prev,
            nextArrow: styles.arrow_next,
          }}
        >
          {data.map(review => (
            <SplideSlide key={review.id}>
              <EducationReview
                className={styles.slide}
                review={review}
              />
            </SplideSlide>
          ))}
        </Slider>
      )}
    </section>
  );
};
export default EducationReviews;
